import { BORDER_RADIUS } from '@ui-kit/constants'

export const MAX_CARD_WIDTH = 327

export const CARD_ELEMENTS_VARIANTS = {
  brandLight: 'brandDark',
  brandLime: 'brandDark',
  uiRedLight: 'uiRed',
  uiOrange: 'uiOrangeLight',
  playground1Light: 'playground1Dark',
  playground2Light: 'playground2Dark',
  playground3Light: 'playground3Dark',
  playground4Light: 'playground4Dark',
  playground5Light: 'playground5Dark',
  playground6Light: 'playground6Dark',
  uiGreyLight: 'uiGreyLight',
} as const

export const DEFAULT_BORDER_RADIUS = 12

export const BORDER_RADIUS_OPTIONS = [
  0,
  ...Object.values(BORDER_RADIUS),
  DEFAULT_BORDER_RADIUS,
  16,
] as (0 | (typeof BORDER_RADIUS)[keyof typeof BORDER_RADIUS] | typeof DEFAULT_BORDER_RADIUS | 16)[]

export type BorderRadius = (typeof BORDER_RADIUS_OPTIONS)[number]

export type CardElementVariant = keyof typeof CARD_ELEMENTS_VARIANTS
